import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import BudgetListPageUI from './BudgetListPageUI.js'
import LocalStorageKeys from '../../cache/LocalStorageKeys'

class BudgetListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      order: null,
      budgetList: null,
      filteredBudgetList: null,
      createBudgetMode: false,
      searchFilter: ''
    }
  }

  render() {
    return (
      <BudgetListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        order={this.state.order}
        budgetList={this.state.budgetList}
        filteredBudgetList={this.state.filteredBudgetList}
        searchFilter={this.state.searchFilter}
        // events
        onRefreshClick={this.onRefreshClick}
        onSearchFilterChange={this.onSearchFilterChange}
        // create modal
        createBudgetMode={this.state.createBudgetMode}
        onCreateBudgetClick={(event) => { this.setState({createBudgetMode: true}) }}
        onCancelCreateBudget={(event) => { this.setState({createBudgetMode: false}) }}
        onCreateBudgetComplete={this.onCreateBudgetComplete}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getOrder(context)
    this.getBudgets(context)
    this.getMessages(context)
  }

  getOrder(context) {
    let cacheManager = new CacheManager({
      // resource: `/api/orders/${this.props.match.params.orderId}`,
      resource: `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}`,
      cacheKey: CacheKeys.Order(this.props.match.params.orderId),
      callback: this.getOrderCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getOrderCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      order: response.estimate,
    })
  }

  getBudgets(context) {
    if (!context.permissions) { // session expired for some reason
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10)
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/estimates/${this.props.match.params.orderId}/budgets`,
      cacheKey: CacheKeys.OrderBudgets(this.props.match.params.orderId),
      callback: this.getBudgetsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBudgetsCallback = (response) => {
    let filtersStr = sessionStorage.getItem(CacheKeys.OrderBudgetsFilter(this.props.match.params.orderId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      budgetList: response.budgetList,
      filteredBudgetList: response.budgetList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
    })

    this.applyFilters(response.budgetList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(budgetList, searchFilter) {
    let filteredList = budgetList

    if (searchFilter)
      filteredList = filteredList.filter(budget =>
        budget.budgetName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        (budget.maker && budget.maker.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))
      )

    this.setState({filteredBudgetList: filteredList})

    let filters = {
      searchFilter: searchFilter,
    }
    sessionStorage.setItem(CacheKeys.OrderBudgetsFilter(this.props.match.params.orderId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Order(this.props.match.params.orderId))
    CacheManager.removeObject(CacheKeys.OrderBudgets(this.props.match.params.orderId))
    this.setState({
      errorList: null,
      budgetList: null,
      filteredBudgetList: null,
      order: null
    }, () => {
      this.getOrder(context)
      this.getBudgets(context)
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({searchFilter: searchFilter})
    this.applyFilters(this.state.budgetList, searchFilter)
  }

  onCreateBudgetComplete = (budget) => {
    CacheManager.removeObject(CacheKeys.OrderBudgets(budget.estimateId))
    this.getBudgets(this.props.context)

    this.setState({ budget: budget })
    setTimeout(() => {
      this.setState({ createBudgetMode: false })
    }, 2000)
  }

  getMessages(context) {
    let arr = [
      'c_refresh', //done
      'c_create_budget',
      'c_no_budget_msg',
      'c_budget_total',
      'c_avail_to_alloc',
      'c_cust_order',
      'c_order_date',
      'c_allocated',
      'c_utilized',
      'c_items',
      'c_budgets',
      'c_invoices',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_ord_budgets', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(BudgetListPageSF)
